import currentSalesChannel from './slice';
export default currentSalesChannel;
